export class PMOParentProjectModel {
    constructor() {
        this.parentProjectId = "";
        this.parentProjectName = "";
    }
}
export default class PMOParentProject extends PMOParentProjectModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
